import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Rx";
import "rxjs/add/observable/of";
import "rxjs/add/operator/do";
import "rxjs/add/operator/delay";
import { Http, RequestOptions, URLSearchParams } from "@angular/http";

import "rxjs/add/observable/throw";
import { DizionarioModel } from "./../models/shared/dizionario.model";
import {
  ILoginModel,
  RichiestaZoneUnitaVenditaModel,
} from "../models/account/ilogin.model";
import { IResetModel } from "../models/account/ilogin-reset.model";
import { IResetRecoverModel } from "../models/account/ilogin-reset-recover.model";
import { IResetRichiestaModel } from "../models/account/ilogin-reset-richiesta.model";
import { LocalDb } from "../core/localdb";
import { Configurations } from "../core/configurations";
import { UserModel } from "../models/user/user.model";
import { guid } from "../core/utilities";
import { LoginResponseModel } from "../models/account/login-response.model";
import { GrantedModel } from "../models/account/granted.model";
import { observeOn } from "rxjs/operator/observeOn";

@Injectable()
export class AuthService {
  isLoggedIn = false;
  //url
  APIAuth = this.configuration.apiBaseUrlUsers;
  ZoneAuth = this.configuration.apiBaseUrlZone;
  MethodLogin = "LoginConq";
  MethodLogoutConq = "LogoutConq";
  MethodConfir = "Confirm";
  MethodIsGranted = "HasAuthorizationConq";
  MethodReset = "ResetPasswordConq";
  MethodImpersonate = "ImpersonateUtenteConq";
  MethodResetRecupera = "ResetAccountFormConq";
  MethodResetRichiesta = "ResetPasswordAccountConq";
  MethodSessionHeartBeat = "SessionHeartbeatConq";
  MethodListUV = "ListaUnitaVenditaConq";
  MethodListZonesUV = "ListaZoneUnitaVenditaConq";
  // store the URL so we can redirect after logging in
  redirectUrl: string;
  LocalUser: LoginResponseModel;

  permissionList: string[] = [];

  private _user: UserModel = null;

  get user(): UserModel {
    if (this._user == null) {
      let u = localStorage.getItem("currentUser");
      if (u) {
        this._user = JSON.parse(u) as UserModel;
      }
    }
    return this._user;
  }

  constructor(private http: Http, private configuration: Configurations) {}
  listaUnitaVendita(): Observable<DizionarioModel[]> {
    let url = this.ZoneAuth + this.MethodListUV;
    return this.http.get(url).map((data) => {
      return data.json() as DizionarioModel[];
    });
  }
  listaZoneUnitaVendita(codiceUV: string): Observable<DizionarioModel[]> {
    let url = this.ZoneAuth + this.MethodListZonesUV;
    let options = new RequestOptions();
    options.params = new URLSearchParams();
    options.params.append("codiceUV", codiceUV);
    return this.http.get(url, options).map((data) => {
      return data.json() as DizionarioModel[];
    });
  }
  login(model: ILoginModel): Observable<LoginResponseModel> {
    //PROD

    let options = new RequestOptions({ withCredentials: true });
    let url = this.APIAuth + this.MethodLogin;
    return this.http
      .post(url, model ,options)
      .map((data) => {
        this.LocalUser = data.json() as LoginResponseModel;
        if (this.LocalUser.isAuthenticated) {
          let user = {
            token: this.LocalUser.userToken,
            username: this.LocalUser.userName,
            email: this.LocalUser.email,
            cognome: this.LocalUser.cognome,
            role: "", //data.ruolo,
            SIUToken: this.LocalUser.siuToken,
            // clono l'array
            authorizations: this.LocalUser.authorizations, //.map(x => Object.assign({}, x))
          };
          localStorage.setItem("currentUser", JSON.stringify(user));
        }
        return this.LocalUser;
      })
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      );
  }

  impersonateUser(idUtenteM: number): Observable<LoginResponseModel> {
    let url =
      this.APIAuth + this.MethodImpersonate + "?" + "idUtente=" + idUtenteM;
    return this.http
      .post(url, null)
      .map((data: any) => {
        this.LocalUser = data.json() as LoginResponseModel;
        if (this.LocalUser.isAuthenticated) {
          let user = {
            token: this.LocalUser.userToken,
            username: this.LocalUser.userName,
            email: this.LocalUser.email,
            cognome: this.LocalUser.cognome,
            role: "", //data.ruolo,
            SIUToken: this.LocalUser.siuToken,
            // clono l'array
            authorizations: this.LocalUser.authorizations, //.map(x => Object.assign({}, x))
          };
          localStorage.setItem("currentUser", JSON.stringify(user));
        }
        return this.LocalUser;
      })
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      );
  }

  logout(redirToBase: boolean): void {
    this.isLoggedIn = false;
    localStorage.removeItem("currentUser");
    localStorage.removeItem("listaUnitaVendita");
    this.http
      .get(this.APIAuth + this.MethodLogoutConq)
      .subscribe((data: any) => {
        if (redirToBase) {
          location.href = Configurations.baseUrl;
        }
      });
  }
  logoutIfSessionExpired(): any {
    return (
      this.http
        .get(this.APIAuth + this.MethodSessionHeartBeat, null)
        //map(((res) => {
        //  return Observable.of(true);
        //})).
        .map((data) => {
          return data;
        })
        .catch((error: any) => {
          if (error.status === 401) {
            this.logout(true);
          }
          return Observable.throw("Sessione scaduta");
        })
    );
  }

  isAuthenticated(model: ILoginModel) {
    return this.isLoggedIn;
  }

  isGranted(permission: string): boolean {
    let isGranted = false;

    if (this.user == null) {
      return false;
    }
    let permissionList = permission.split(",");
    let permissionFound = "";
    let found = this.user.authorizations.find((x) => {
      permissionFound = permissionList.find((p) => p === x);
      return permissionFound === x;
    });
    if (found !== undefined) {
      return found === permissionFound;
    } else {
      return false;
    }
  }

  //reset recupera password
  resetRecoverPassword(model: IResetRecoverModel): Observable<Response> {
    let url = this.APIAuth + this.MethodResetRecupera;
    return this.http
      .post(url, model)
      .map((res) => {
        return res.json();
      })
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      );
  }

  //reset richiedi recupero password
  resetRichiediPassword(model: IResetRichiestaModel): Observable<Response> {
    let url = this.APIAuth + this.MethodResetRichiesta;
    return this.http
      .post(url, model)
      .map((res) => {
        return res.json();
      })
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      );
  }

  //reset password scaduta
  resetPassword(model: IResetModel): Observable<Response> {
    let url = this.APIAuth + this.MethodReset;
    return this.http
      .post(url, model)
      .map((res) => {
        return res.json();
      })
      .catch((error: any) =>
        Observable.throw(error.json().error || "Server error")
      );
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/services/auth.service.ts